import axios from "axios";
import { URL_BASE } from "../config/url-server";


const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")





export const applicationsByDay = async (params) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/phenological-by-day",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export default {
  applicationsByDay
};
